import { render, staticRenderFns } from "./mentorRegisterList.vue?vue&type=template&id=2ed1905e"
import script from "./mentorRegisterList.vue?vue&type=script&lang=js"
export * from "./mentorRegisterList.vue?vue&type=script&lang=js"
import style0 from "./mentorRegisterList.vue?vue&type=style&index=0&id=2ed1905e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports